export const akidcalledbeastNFTs = [
  
  {
    "id": "beast-9899",
    "name": "BEAST #9899",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9899.png",
    "price": "0.7"
  },
  {
    "id": "beast-9896",
    "name": "BEAST #9896",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9896.png",
    "price": "0.3"
  },
  {
    "id": "beast-9893",
    "name": "BEAST #9893",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9893.png",
    "price": "0.8"
  },
  {
    "id": "beast-9895",
    "name": "BEAST #9895",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9895.png",
    "price": "0.2"
  },
  {
    "id": "beast-9898",
    "name": "BEAST #9898",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9898.png",
    "price": "0.6"
  },
  {
    "id": "beast-9900",
    "name": "BEAST #9900",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9900.png",
    "price": "0.4"
  },
  {
    "id": "beast-9894",
    "name": "BEAST #9894",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9894.png",
    "price": "0.9"
  },
  {
    "id": "beast-9897",
    "name": "BEAST #9897",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9897.png",
    "price": "0.1"
  },
  {
    "id": "beast-9892",
    "name": "BEAST #9892",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9892.png",
    "price": "0.5"
  },
  {
    "id": "beast-9890",
    "name": "BEAST #9890",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9890.png",
    "price": "0.7"
  },
  {
    "id": "beast-9887",
    "name": "BEAST #9887",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9887.png",
    "price": "0.3"
  },
  {
    "id": "beast-9881",
    "name": "BEAST #9881",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9881.png",
    "price": "0.8"
  },
  {
    "id": "beast-9889",
    "name": "BEAST #9889",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9889.png",
    "price": "0.2"
  },
  {
    "id": "beast-9885",
    "name": "BEAST #9885",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9885.png",
    "price": "0.6"
  },
  {
    "id": "beast-9879",
    "name": "BEAST #9879",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9879.png",
    "price": "0.4"
  },
  {
    "id": "beast-9876",
    "name": "BEAST #9876",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9876.png",
    "price": "0.9"
  },
  {
    "id": "beast-9875",
    "name": "BEAST #9875",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9875.png",
    "price": "0.1"
  },
  {
    "id": "beast-9859",
    "name": "BEAST #9859",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9859.png",
    "price": "0.5"
  },
  {
    "id": "beast-9860",
    "name": "BEAST #9860",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9860.png",
    "price": "0.7"
  },
  {
    "id": "beast-9852",
    "name": "BEAST #9852",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9852.png",
    "price": "0.3"
  },
  {
    "id": "beast-9855",
    "name": "BEAST #9855",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9855.png",
    "price": "0.8"
  },
  {
    "id": "beast-9853",
    "name": "BEAST #9853",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9853.png",
    "price": "0.2"
  },
  {
    "id": "beast-9848",
    "name": "BEAST #9848",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9848.png",
    "price": "0.6"
  },
  {
    "id": "beast-9846",
    "name": "BEAST #9846",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9846.png",
    "price": "0.4"
  },
  {
    "id": "beast-9845",
    "name": "BEAST #9845",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9845.png",
    "price": "0.9"
  },
  {
    "id": "beast-9844",
    "name": "BEAST #9844",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9844.png",
    "price": "0.1"
  },
  {
    "id": "beast-9886",
    "name": "BEAST #9886",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9886.png",
    "price": "0.5"
  },
  {
    "id": "beast-9883",
    "name": "BEAST #9883",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9883.png",
    "price": "0.7"
  },
  {
    "id": "beast-9882",
    "name": "BEAST #9882",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9882.png",
    "price": "0.3"
  },
  {
    "id": "beast-9880",
    "name": "BEAST #9880",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9880.png",
    "price": "0.8"
  },
  {
    "id": "beast-9878",
    "name": "BEAST #9878",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9878.png",
    "price": "0.2"
  },
  {
    "id": "beast-9877",
    "name": "BEAST #9877",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9877.png",
    "price": "0.6"
  },
  {
    "id": "beast-9874",
    "name": "BEAST #9874",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9874.png",
    "price": "0.4"
  },
  {
    "id": "beast-9873",
    "name": "BEAST #9873",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9873.png",
    "price": "0.9"
  },
  {
    "id": "beast-9871",
    "name": "BEAST #9871",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9871.png",
    "price": "0.1"
  },
  {
    "id": "beast-9870",
    "name": "BEAST #9870",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9870.png",
    "price": "0.5"
  },
  {
    "id": "beast-9869",
    "name": "BEAST #9869",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9869.png",
    "price": "0.7"
  },
  {
    "id": "beast-9867",
    "name": "BEAST #9867",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9867.png",
    "price": "0.3"
  },
  {
    "id": "beast-9868",
    "name": "BEAST #9868",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9868.png",
    "price": "0.8"
  },
  {
    "id": "beast-9866",
    "name": "BEAST #9866",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9866.png",
    "price": "0.2"
  },
  {
    "id": "beast-9865",
    "name": "BEAST #9865",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9865.png",
    "price": "0.6"
  },
  {
    "id": "beast-9864",
    "name": "BEAST #9864",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9864.png",
    "price": "0.4"
  },
  {
    "id": "beast-9862",
    "name": "BEAST #9862",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9862.png",
    "price": "0.9"
  },
  {
    "id": "beast-9863",
    "name": "BEAST #9863",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9863.png",
    "price": "0.1"
  },
  {
    "id": "beast-9861",
    "name": "BEAST #9861",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9861.png",
    "price": "0.5"
  },
  {
    "id": "beast-9858",
    "name": "BEAST #9858",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9858.png",
    "price": "0.7"
  },
  {
    "id": "beast-9856",
    "name": "BEAST #9856",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9856.png",
    "price": "0.3"
  },
  {
    "id": "beast-9854",
    "name": "BEAST #9854",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9854.png",
    "price": "0.8"
  },
  {
    "id": "beast-9851",
    "name": "BEAST #9851",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9851.png",
    "price": "0.2"
  },
  {
    "id": "beast-9849",
    "name": "BEAST #9849",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9849.png",
    "price": "0.6"
  },
  {
    "id": "beast-9850",
    "name": "BEAST #9850",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9850.png",
    "price": "0.4"
  },
  {
    "id": "beast-9847",
    "name": "BEAST #9847",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9847.png",
    "price": "0.9"
  },
  {
    "id": "beast-9843",
    "name": "BEAST #9843",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9843.png",
    "price": "0.5"
  },
  {
    "id": "beast-9891",
    "name": "BEAST #9891",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9891.png",
    "price": "0.7"
  },
  {
    "id": "beast-9884",
    "name": "BEAST #9884",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9884.png",
    "price": "0.3"
  },
  {
    "id": "beast-9872",
    "name": "BEAST #9872",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9872.png",
    "price": "0.8"
  },
  {
    "id": "beast-9857",
    "name": "BEAST #9857",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9857.png",
    "price": "0.2"
  },
  {
    "id": "beast-9888",
    "name": "BEAST #9888",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9888.png",
    "price": "0.6"
  },
  {
    "id": "beast-9842",
    "name": "BEAST #9842",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9842.png",
    "price": "0.4"
  },
  {
    "id": "beast-9841",
    "name": "BEAST #9841",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9841.png",
    "price": "0.9"
  },
  {
    "id": "beast-9839",
    "name": "BEAST #9839",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9839.png",
    "price": "0.1"
  },
  {
    "id": "beast-9838",
    "name": "BEAST #9838",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9838.png",
    "price": "0.5"
  },
  {
    "id": "beast-9840",
    "name": "BEAST #9840",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9840.png",
    "price": "0.7"
  },
  {
    "id": "beast-9835",
    "name": "BEAST #9835",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9835.png",
    "price": "0.3"
  },
  {
    "id": "beast-9834",
    "name": "BEAST #9834",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9834.png",
    "price": "0.8"
  },
  {
    "id": "beast-9837",
    "name": "BEAST #9837",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9837.png",
    "price": "0.2"
  },
  {
    "id": "beast-9836",
    "name": "BEAST #9836",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9836.png",
    "price": "0.6"
  },
  {
    "id": "beast-9833",
    "name": "BEAST #9833",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9833.png",
    "price": "0.4"
  },
  {
    "id": "beast-9832",
    "name": "BEAST #9832",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9832.png",
    "price": "0.9"
  },
  {
    "id": "beast-9831",
    "name": "BEAST #9831",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9831.png",
    "price": "0.1"
  },
  {
    "id": "beast-9830",
    "name": "BEAST #9830",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9830.png",
    "price": "0.5"
  },
  {
    "id": "beast-9829",
    "name": "BEAST #9829",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9829.png",
    "price": "0.7"
  },
  {
    "id": "beast-9828",
    "name": "BEAST #9828",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9828.png",
    "price": "0.3"
  },
  {
    "id": "beast-9827",
    "name": "BEAST #9827",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9827.png",
    "price": "0.8"
  },
  {
    "id": "beast-9826",
    "name": "BEAST #9826",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9826.png",
    "price": "0.2"
  },
  {
    "id": "beast-9823",
    "name": "BEAST #9823",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9823.png",
    "price": "0.6"
  },
  {
    "id": "beast-9824",
    "name": "BEAST #9824",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9824.png",
    "price": "0.4"
  },
  {
    "id": "beast-9825",
    "name": "BEAST #9825",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9825.png",
    "price": "0.9"
  },
  {
    "id": "beast-9822",
    "name": "BEAST #9822",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9822.png",
    "price": "0.1"
  },
    {
    "id": "beast-9821",
    "name": "BEAST #9821",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9821.png",
    "price": "0.5"
  },
  {
    "id": "beast-9818",
    "name": "BEAST #9818",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9818.png",
    "price": "0.7"
  },
  {
    "id": "beast-9817",
    "name": "BEAST #9817",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9817.png",
    "price": "0.3"
  },
  {
    "id": "beast-9815",
    "name": "BEAST #9815",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9815.png",
    "price": "0.8"
  },
  {
    "id": "beast-9814",
    "name": "BEAST #9814",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9814.png",
    "price": "0.2"
  },
  {
    "id": "beast-9813",
    "name": "BEAST #9813",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9813.png",
    "price": "0.6"
  },
  {
    "id": "beast-9812",
    "name": "BEAST #9812",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9812.png",
    "price": "0.4"
  },
  {
    "id": "beast-9811",
    "name": "BEAST #9811",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9811.png",
    "price": "0.9"
  },
  {
    "id": "beast-9808",
    "name": "BEAST #9808",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9808.png",
    "price": "0.1"
  },
  {
    "id": "beast-9809",
    "name": "BEAST #9809",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9809.png",
    "price": "0.5"
  },
  {
    "id": "beast-9810",
    "name": "BEAST #9810",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9810.png",
    "price": "0.7"
  },
  {
    "id": "beast-9807",
    "name": "BEAST #9807",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9807.png",
    "price": "0.3"
  },
  {
    "id": "beast-9805",
    "name": "BEAST #9805",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9805.png",
    "price": "0.8"
  },
  {
    "id": "beast-9804",
    "name": "BEAST #9804",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9804.png",
    "price": "0.2"
  },
  {
    "id": "beast-9803",
    "name": "BEAST #9803",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9803.png",
    "price": "0.6"
  },
  {
    "id": "beast-9802",
    "name": "BEAST #9802",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9802.png",
    "price": "0.4"
  },
  {
    "id": "beast-9801",
    "name": "BEAST #9801",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9801.png",
    "price": "0.9"
  },
  {
    "id": "beast-9800",
    "name": "BEAST #9800",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9800.png",
    "price": "0.1"
  },
  {
    "id": "beast-9798",
    "name": "BEAST #9798",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9798.png",
    "price": "0.5"
  },
  {
    "id": "beast-9796",
    "name": "BEAST #9796",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9796.png",
    "price": "0.7"
  },
  {
    "id": "beast-9797",
    "name": "BEAST #9797",
    "image": "https://ipfs.io/ipfs/QmQYeDSnhqUbNJ7XeMGSUV5KdHHMk5Hkjk2BpShZhKZ7gU/9797.png",
    "price": "0.3"
  }



];